import get from 'lodash/get';
import property from 'lodash/property';
import { createSelector } from 'reselect';

import getParent from '../selectors';
import { getSelectedParameters } from '../../../dataset/parameters/selectors';

export const getSettingsPane = state => getParent(state).settingsPane;

export const getPrimaryParameterName = createSelector(
  getSettingsPane, property('primary')
);

export const getSecondaryParameterName = createSelector(
  getSettingsPane, property('secondary')
);

const makeParameterTypeSelector = parameterNameSelector =>
  createSelector(
    getSelectedParameters,
    parameterNameSelector,

    (selectedParameters, parameterName) =>
      get(selectedParameters[parameterName], 'targetType')
  );

export const getPrimaryParameterType =
  makeParameterTypeSelector(getPrimaryParameterName);

export const getSecondaryParameterType =
  makeParameterTypeSelector(getSecondaryParameterName);

export const getTypeOfFrequencyHistogram = createSelector(
  getSettingsPane, property('typeOfFrequencyHistogram')
);

export const getTypeOfFrequencyBarChart = createSelector(
  getSettingsPane, property('typeOfFrequencyBarChart')
);

export const getTypeOfFrequencyPieChart = createSelector(
  getSettingsPane, property('typeOfFrequencyPieChart')
);

export default getSettingsPane;
